import React from "react";
import styled from "styled-components";
import { getThemeColor } from "../../utils";
import Flex from "../blocks/Flex";

const EmphasisLine = styled.div`
  border-top: .25rem solid ${getThemeColor("dark")};
  padding-bottom: .4375rem;
  width: 2rem;
`;

export default ({ children, align = "flex-start" }) =>
  <Flex align={align} direction="column">
    <EmphasisLine />
    {children}
  </Flex>;



// WEBPACK FOOTER //
// ./src/components/atoms/Emphasis.js